export const iconFontAwesomeHumanitarianPersonDrowning = (
	<i className="fa-solid fa-person-drowning"></i>
);
